/**
 * Shared VMS pending / pending-approval badge colors (pre-onboarding chip: #fef9c3 / #854d0e / #fde047).
 */

/** Rounded pill with border (lists, RFP, FA, approver rows). */
export const VMS_PENDING_STATUS_BADGE_CLASS =
  'border border-yellow-300 bg-yellow-100 text-yellow-900';

/** Ring-style pill (annexure hub cards). */
export const VMS_PENDING_STATUS_BADGE_RING_CLASS =
  'bg-yellow-100 text-yellow-900 ring-yellow-300';

/** Compact uppercase chip (inline banners). */
export const VMS_PENDING_APPROVAL_CHIP_INLINE_CLASS =
  'inline-flex max-w-[9.5rem] items-center truncate rounded-full border border-yellow-300 bg-yellow-100 px-2 py-0.5 text-[9px] font-bold uppercase leading-tight tracking-wide text-yellow-900 sm:max-w-none sm:text-[10px]';

export function isVmsPendingLikeStatus(status: string | null | undefined): boolean {
  const s = String(status ?? '').toLowerCase().trim();
  if (!s) return false;
  if (s === 'pending' || s === 'pending_approval') return true;
  if (s === 'pending_annexure_approval' || s === 'pending_business_heads') return true;
  if (s === 'pending_annexure_7') return true;
  if (s.startsWith('pending_at_approver') || s.startsWith('pending_at_')) return true;
  if (s.startsWith('pending_')) return true;
  return false;
}

/** Business-head / workflow participant row (pending / approved / rejected). */
export function vmsApproverParticipantBadgeClass(status: string | null | undefined): string {
  const s = String(status ?? 'pending').toLowerCase();
  if (s === 'approved') return 'bg-green-100 text-green-800';
  if (s === 'rejected') return 'bg-red-100 text-red-800';
  return VMS_PENDING_STATUS_BADGE_CLASS;
}

/**
 * Workflow item status pill (RFP, FA, vendor proposal, register list, etc.).
 * Non-pending statuses keep existing semantic colors.
 */
export function vmsWorkflowStatusBadgeClass(status: string | null | undefined): string {
  const s = String(status ?? '').toLowerCase().trim();
  if (isVmsPendingLikeStatus(s)) return VMS_PENDING_STATUS_BADGE_CLASS;
  if (s === 'draft') return 'bg-amber-100 text-amber-800 border-amber-200';
  if (s === 'needs_more_information') return 'bg-orange-100 text-orange-900 border-orange-200';
  if (s === 'approved') return 'bg-green-100 text-green-800 border-green-200';
  if (s === 'rejected') return 'bg-red-100 text-red-800 border-red-200';
  if (s === 'submitted') return 'bg-sky-100 text-sky-900 border-sky-200';
  return 'bg-gray-100 text-gray-700 border-gray-200';
}

/** Solid uppercase chrome pills (initiation thread header, pre-onboarding view). */
export function vmsInitiationChromeStatusBadgeClass(status: string): string {
  const s = String(status ?? '').toLowerCase().trim();
  if (s === 'approved') return 'bg-emerald-700 text-white';
  if (s === 'rejected') return 'bg-red-700 text-white';
  if (s === 'draft') return 'bg-amber-600 text-white';
  if (isVmsPendingLikeStatus(s)) {
    return 'border border-yellow-300 bg-yellow-100 text-yellow-900';
  }
  return 'bg-primary-700 text-white';
}
